/* eslint-disable */

import _ from 'lodash';

let authInfo = null;

const checkEnable = (code) => {
  // return false;
  if (authInfo && code) {
    if (authInfo.isadmin == 0) { // isadmin  0需要判断权限 1超级管理员无需权限判断
      const group = Array.isArray(authInfo.group) ? authInfo.group : [];
      return group.includes(code);
    }
  }
  return true;
};

const checkAuthCode = (el, binding, vnode) => {
  const { value } = binding
  if (value) {
    if (typeof value === 'string') {
      const isEnable = checkEnable(value);
      if (!isEnable) {
        el.parentNode && el.parentNode.removeChild(el);
        let parent = vnode.context.$parent;
        let index = parent.$children.indexOf(vnode.context);
        parent.$children.splice(index, 1);
      }
    }
  }
};

export default {
  inserted(el, binding, vnode) {
    checkAuthCode(el, binding, vnode);
  },
  update(el, binding, vnode) {
    checkAuthCode(el, binding, vnode);
  },
  setAuthInfo(info) {
    authInfo = _.cloneDeep(info);
  }
}
